import "$styles/pure-willamette.css"
import "$styles/syntax-highlighting.css"

import Willamette from "willamette"

Willamette.init()
